/**
 * 서비스 약관 및 마이데이터 요청 동의 정보 조회
 */
import { apiClient } from "./api";

// 새로운 Dataset 관련 인터페이스 및 서비스
export interface Dataset {
  datasetCode: string;
  datasetName: string;
  provideInstitutionNo: string | null;
  provisionDivisionCode: string;
  agreementStatus?: "AGREEMENT" | "NONE"; // 사용자의 동의 상태
}

export interface UpdateDatasetRequest {
  userDatasetAgreementList: Array<{
    datasetCode: string;
    agreementStatus: "AGREEMENT" | "NONE";
  }>;
}

export interface UpdateDatasetResponse {
  success: boolean;
  message: string;
}

/**
 * 유저의 항목 동의여부 조회
 */
export const getDatasets = async (): Promise<Dataset[]> => {
  try {
    const response = await apiClient.get<Dataset[]>("/datasets");
    return response.data;
  } catch (error) {
    console.error("데이터셋 정보 조회 중 오류:", error);
    throw error;
  }
};

/**
 * 데이터셋 동의 정보 업데이트
 */
export const updateDatasets = async (
  data: UpdateDatasetRequest
): Promise<UpdateDatasetResponse> => {
  try {
    await apiClient.put("/datasets", data);
    return {
      success: true,
      message: "데이터셋 동의 정보가 성공적으로 업데이트되었습니다.",
    };
  } catch (error) {
    console.error("데이터셋 동의 정보 업데이트 중 오류:", error);
    return {
      success: false,
      message: "데이터셋 동의 정보 업데이트 중 오류가 발생했습니다.",
    };
  }
};

// 데이터셋 이력 관련 인터페이스 및 서비스
export interface DatasetAgreementHistory {
  historySequence: string;
  utilizationUserNo: string;
  agreementSystemDivisionCode: string;
  datasetCode: string;
  datasetName: string;
  agreementStatus: string;
  agreementDateTime: string;
}

export interface DatasetHistoryResponse {
  datasetAgreementHistoryList: DatasetAgreementHistory[];
}

/**
 * 유저의 항목 동의여부 이력 조회
 */
export const getDatasetHistory = async (): Promise<
  DatasetAgreementHistory[]
> => {
  try {
    const response = await apiClient.get<DatasetHistoryResponse>(
      "/datasets/history"
    );
    return response.data.datasetAgreementHistoryList;
  } catch (error) {
    console.error("데이터셋 이력 조회 중 오류:", error);
    throw error;
  }
};
